import apiClient from '@/lib/api/apiClient'
import { showApiError } from '@/lib/utils/notifications'

/** Same as Angular `downloadFile`: strip bucket URL so `url` query is the S3 key/path segment. */
export function stripCertificatePathToS3Key(filePath: string): string {
  return filePath.replace(/^https?:\/\/[^/]+\/?/, '')
}

/**
 * Angular `stock-list.component.ts` `downloadFile(stock_id, certificate_path, 'CERTIFICATE')`:
 * GET `/serve-file-config/CERTIFICATE/{stock_id}/?url={encodeURIComponent(s3Key)}` → blob → `window.open` object URL.
 */
export async function openStockCertificatePreview(
  stockId: number,
  certificatePath: string,
): Promise<void> {
  if (!certificatePath || !stockId) return
  const s3Key = stripCertificatePathToS3Key(certificatePath)
  const encodedPath = encodeURIComponent(s3Key)
  try {
    const { data } = await apiClient.get<Blob>(
      `/serve-file-config/CERTIFICATE/${stockId}/?url=${encodedPath}`,
      { responseType: 'blob' },
    )
    const objectUrl = window.URL.createObjectURL(data)
    window.open(objectUrl, '_blank', 'noopener,noreferrer')
  } catch (error) {
    showApiError(error)
  }
}
